import { render, staticRenderFns } from "./personalcreate.vue?vue&type=template&id=71634dd9"
import script from "./personalcreate.vue?vue&type=script&lang=js"
export * from "./personalcreate.vue?vue&type=script&lang=js"
import style0 from "./personalcreate.vue?vue&type=style&index=0&id=71634dd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports